// extracted by mini-css-extract-plugin
module.exports = {"serverError":"ErrorBlock-module__serverError___CutjA"};